interface ThumbsUpIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function ThumbsUpIcon({ 
  size = 24, 
  color = '#1B2831',
  className = '' 
}: ThumbsUpIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M5 22H17.73C18.4318 21.9998 19.1113 21.7535 19.6503 21.304C20.1893 20.8546 20.5537 20.2303 20.68 19.54L21.95 12.54C22.0291 12.1076 22.0123 11.663 21.9006 11.2378C21.7889 10.8126 21.5851 10.4172 21.3037 10.0794C21.0222 9.7417 20.67 9.47 20.2719 9.2834C19.8738 9.0969 19.4396 9.0001 19 9H14.44L15 7.57C15.2329 6.9439 15.3105 6.2706 15.2261 5.6079C15.1416 4.9452 14.8977 4.3129 14.5152 3.7652C14.1327 3.2175 13.623 2.7708 13.0299 2.4633C12.4368 2.1559 11.778 1.9969 11.11 2C10.9176 2.0004 10.7295 2.0563 10.5681 2.1609C10.4067 2.2656 10.2789 2.4146 10.2 2.59L7.35 9H5C4.20435 9 3.44129 9.31607 2.87868 9.87868C2.31607 10.4413 2 11.2044 2 12V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22ZM9 10.21L11.72 4.09C11.9983 4.1742 12.2564 4.3145 12.4785 4.5022C12.7005 4.69 12.8817 4.9212 13.011 5.1817C13.1403 5.4421 13.2149 5.7263 13.2302 6.0166C13.2455 6.307 13.2012 6.5974 13.1 6.87L12.57 8.3C12.4571 8.6023 12.4189 8.9273 12.4589 9.2475C12.4988 9.5677 12.6156 9.8735 12.7993 10.1387C12.983 10.404 13.2282 10.6209 13.5139 10.7708C13.7996 10.9208 14.1173 10.9994 14.44 11H19C19.1469 10.9998 19.2921 11.0319 19.4252 11.0941C19.5583 11.1563 19.676 11.2471 19.77 11.36C19.8663 11.4713 19.9369 11.6025 19.9766 11.7443C20.0164 11.886 20.0244 12.0348 20 12.18L18.73 19.18C18.6874 19.413 18.5635 19.623 18.3803 19.773C18.1972 19.923 18.0267 19.9963 17.73 20H9V10.21ZM4 12C4 11.7348 4.10536 11.4804 4.29289 11.2929C4.48043 11.1054 4.73478 11 5 11H7V20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V12Z" fill={color} />
    </svg>
  );
}
